// useTemplates.ts
import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { useAuthedAxios } from "hooks/core/useAuthedAxios"
import { queryKeys } from "api/queryKeys"
import { getTemplateCatalogue } from "api/Engine/templates"
import { TemplateCatalogue } from "types/template.types"

/**
 * The template catalogue (every public and private template). It changes
 * only when someone adds a .tpl file, so it is cached for 5 minutes.
 *
 * @param enabled - Fetch only while the gallery is open
 */
export const useTemplateCatalogue = (
  enabled: boolean = true
): UseQueryResult<TemplateCatalogue> => {
  const getAxios = useAuthedAxios()

  return useQuery({
    queryKey: queryKeys.templates.catalogue,
    enabled,
    staleTime: 5 * 60_000,
    meta: { errorTitle: "Could not load the templates" },
    queryFn: async (): Promise<TemplateCatalogue> =>
      getTemplateCatalogue(await getAxios()),
  })
}
